import styled from 'styled-components';

export const SFlex = styled.div<{ disable?: boolean }>`
  display: flex;
  cursor: ${({ disable }) => (disable ? 'not-allowed' : 'pointer')};
`;
